// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"190":"7dad9ed9","726":"a28e9839","775":"b404bada","986":"f15699ce"}[chunkId] + ".chunk.js";
};